var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22433_235476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.77505 1.66641C5.87505 1.78308 2.62505 5.02474 2.50005 8.92474C2.39172 12.2914 4.51672 15.1747 7.50005 16.2331V17.4997C7.50005 17.9581 7.87505 18.3331 8.33339 18.3331C8.79172 18.3331 9.16672 17.9581 9.16672 17.4997V16.6164C9.44172 16.6497 9.71672 16.6664 10.0001 16.6664C10.2834 16.6664 10.5584 16.6497 10.8334 16.6164V17.4997C10.8334 17.9581 11.2084 18.3331 11.6667 18.3331C12.1251 18.3331 12.5001 17.9581 12.5001 17.4997V16.2247C15.4084 15.1914 17.5001 12.4164 17.5001 9.16641C17.5001 4.95808 14.0167 1.54141 9.77505 1.66641ZM11.2834 12.2581L10.0001 13.5414C9.65839 13.8831 9.09172 13.8831 8.75005 13.5414C8.40839 13.1997 8.40839 12.6331 8.75005 12.2914L9.16672 11.8747L8.71672 11.4247C8.39172 11.0997 8.39172 10.5747 8.71672 10.2497L10.0001 8.95808C10.3417 8.61641 10.9084 8.61641 11.2501 8.95808C11.5917 9.29974 11.5917 9.86641 11.2501 10.2081L10.8334 10.6247L11.2834 11.0747C11.6084 11.3997 11.6084 11.9331 11.2834 12.2581ZM12.5001 7.49974H7.50005C7.04172 7.49974 6.66672 7.12474 6.66672 6.66641C6.66672 6.20808 7.04172 5.83308 7.50005 5.83308H12.5001C12.9584 5.83308 13.3334 6.20808 13.3334 6.66641C13.3334 7.12474 12.9584 7.49974 12.5001 7.49974Z",
    fill: "#6B7684"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22433_235476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricMeter);
export default __webpack_public_path__ + "static/media/electricMeter.10e9c62e02ea9ca55f77483e03a53024.svg";
export { ForwardRef as ReactComponent };